import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  OnInit,
} from '@angular/core';
import { ITrackingAction, ITrackingObject } from '../models/tracking.data';
import { I2gNgTrackingService } from '../i2g-ng-tracking.service';
import { buildButtonTappedTrackingAction } from '../i2g-ng-tracking-action.builder';

@Directive({
  selector: '[i2gTrackable]',
})
export class I2gTrackableDirective implements OnInit {
  @Input() trackingObject: ITrackingObject;
  @Input() trackingAction: ITrackingAction;
  @Input() trackingAdditionalProperties: any;
  @Input() i2gTrackable: string;

  private _el: any;

  constructor(
    private _elementRef: ElementRef,
    private _trackingService: I2gNgTrackingService
  ) {}

  ngOnInit() {
    this._el = this._elementRef.nativeElement;
  }

  @HostListener('click', [])
  onClickEvent() {
    if (this.trackingAction || this.i2gTrackable) {
      const trackingAction =
        this.trackingAction ||
        buildButtonTappedTrackingAction(this.i2gTrackable);
      this._trackingService.trackEvent(
        this.trackingObject,
        trackingAction,
        this.trackingAdditionalProperties
      );
    }
  }
}
